import { GatewayExportDocumentsApi } from "@src/api/export-document.api";
import { downloadFile } from "@src/helper/file.helper";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import { displayErrorToast } from "@endya-conformite/ui-kit";
import { GatewayExportDocuments } from "@conformite/gateway";
import styles from "./GetDocumentsPage.module.scss";

export function GetDocumentsPage() {
  const navigate = useNavigate();
  const params = useParams<{
    type: GatewayExportDocuments.ExportDocumentType;
  }>();

  useEffect(() => {
    const fetchAndDownload = async () => {
      if (!params.type) {
        displayErrorToast("Type de document non spécifié.");
        navigate("/");
        return;
      }
      const { data } = await GatewayExportDocumentsApi.getSignedURL(
        params.type
      );

      if (data?.url) {
        downloadFile(data.url);
      } else {
        displayErrorToast("Il n'y a pas de document à télécharger");
      }
      navigate("/");
    };

    void fetchAndDownload();
  }, [navigate, params]);

  return <Loader className={styles.loader} />;
}
